//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.MoveBuilder.js";
import "../CAM/CAM.ExpressionDouble.js";
let d=[[[1,"AxisValueX",0,"CAM.ExpressionDouble",0],[1,"AxisValueY",0,"CAM.ExpressionDouble",0],[1,"DeltaX",0,"CAM.ExpressionDouble",1],[1,"DeltaY",0,"CAM.ExpressionDouble",1],[1,"HelicalPitch",0,"CAM.ExpressionDouble",0],[0,"Intent",1,0],[1,"LeadAngle",0,"CAM.ExpressionDouble",0],[1,"SpiralPitch",0,"CAM.ExpressionDouble",0],[1,"SweepAngle",0,"CAM.ExpressionDouble",0],[1,"TiltAngle",0,"CAM.ExpressionDouble",0]],[],[]];
SPLM.CAM.AngularAboutAxisMoveBuilder = class extends SPLM.CAM.MoveBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.AngularAboutAxisMoveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.AngularAboutAxisMoveBuilder.MoveIntent = Object.freeze({
    "Absolute" : "Absolute", "Incremental" : "Incremental"});

export default SPLM;